export default __webpack_public_path__ + "static/media/rocket_anim_31.898aacdf.png";